import { Injectable } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, AbstractControl, FormControl } from '@angular/forms';

import { FormMessageBulderService, IFormMessageData } from './form-message-builder.service';

import { IFormControlsService } from '../service-interfaces/form-controls.interface';

class ErrorMessage {
  constructor(public name: string = null, public value: string = null) {}
}

@Injectable()
export class FormBuilderService {
  constructor(private formBuilder: UntypedFormBuilder, private formMessageBulderService: FormMessageBulderService) {}

  /*DEPRECATE*/
  buildForm(
    formModel: any,
    formErrors: any,
    formMessages: any,
    isPrepareErrorMessageNow: boolean = false,
    validateOnlyDirtyControls: boolean = true
  ): UntypedFormGroup {
    const form: UntypedFormGroup = this.formBuilder.group(formModel);
    const formMessageData: IFormMessageData = {
      form: form,
      formErrors: formErrors,
      formMessages: formMessages,
    };

    form.valueChanges.subscribe((data) =>
      this.formMessageBulderService.onValueChange(formMessageData, validateOnlyDirtyControls)
    );

    if (isPrepareErrorMessageNow) {
      this.formMessageBulderService.onValueChange(formMessageData, validateOnlyDirtyControls);
    }

    return form;
  }

  buildNewForm(model: any, form: any, formControls: IFormControlsService) {
    const formModel = Object.keys(form).reduce((result, controllName) => {
      result[controllName] = [model[controllName], form[controllName].validators];

      return result;
    }, {});

    const formGroup = this.formBuilder.group(formModel);

    formGroup.valueChanges.subscribe(() => {
      Object.keys(form).forEach((controllName) => {
        const formGroupControl = formGroup.get(controllName);
        const formControl = form[controllName];

        formControl.errors =
          formGroupControl && (formControls.isShowAllErrors || formGroupControl.dirty) && !formGroupControl.valid
            ? Object.keys(formGroupControl.errors).map(
                (errorName) => new ErrorMessage(errorName, formControl.errorMessages[errorName])
              )
            : [];
      });
    });

    return formGroup;
  }

  validateNestableForms(parentForm: AbstractControl) {
    const controls = parentForm['controls'];

    if (!(controls && Object.keys(controls).length)) {
      /** if parentForm does not have nested controls -> exit */
      return;
    }

    parentForm.updateValueAndValidity();

    Object.keys(controls).forEach((controlName) => {
      const control = controls[controlName];
      this.validateNestableForms(control);
    });
  }
}
